import React from 'react';
import styled from 'styled-components';

const Mention = styled.span`
  margin: 0 0 0 24px;
  padding: 3px 10px;
  color: ${props => props.theme.secondaryColor};
  background-color: #e3e9ee;
  font-size: 10px;
  font-weight: ${props => props.theme.fontWeightHeavy};
  text-align: center;
  border-radius: 10px;
  height: 16px;

  ${props => props.theme.isMobile && `
    margin-left: auto !important;
  `};
`;

export default function MentionTag() {
  return (
    <Mention>Mention</Mention>
  );
}
